export default function PaymentMethodDescription({description}) {
    if (description) {
        return (
            <p className={'wc-ppcp-payment-method__description'}>{description}</p>
        )
    }
    return null;
}
